const config = {
  // Force API URL for production
  get API_URL() {
    // In production, always use /api proxy
    if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
      return "/api";
    }
    return import.meta.env.VITE_API_BASE_URL || "/api";
  },
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
};

export default config;
